const STYLE_ID = 'cart-installments-one-line';
const SHOP_PAY_BRAND_STYLE_ID = 'cart-installments-shop-pay-brand';
const SHOP_PAY_BRAND_COLOR = '#fff1db';

function isMobileViewport() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function getInstallmentsFontSize() {
  return isMobileViewport() ? 'clamp(9px, 2.65vw, 10px)' : '11px';
}

function getInstallmentsCss(options) {
  options = options || {};
  const isMobile = isMobileViewport();
  const fontSize = getInstallmentsFontSize();
  const brandShopPay = !!options.brandShopPay;
  const svgHeight = brandShopPay ? (isMobile ? '0.78em' : '0.88em') : '1em';
  // Desktop: center-align the Shop Pay mark with the text line (baseline leaves it too high)
  const contentAlign = brandShopPay ? (isMobile ? 'baseline' : 'center') : 'center';
  const contentGap = brandShopPay ? '0.08em' : '0.25em';
  const installmentsGap = brandShopPay ? '0.04em' : '0.25em';
  const ctaFontSize = brandShopPay
    ? (isMobile ? 'clamp(8px, 2.35vw, 9px)' : '10px')
    : 'inherit';
  const svgTransform = 'transform: none !important;';

  // PDP mobile: line 1 = financing copy + logo, line 2 = View sample plans only (both right-aligned)
  const wrapCtaOnMobile = brandShopPay && isMobile;

  if (wrapCtaOnMobile) {
    return `
  #shopify-installments-content {
    display: flex !important;
    flex-flow: row wrap !important;
    align-items: baseline !important;
    justify-content: flex-end !important;
    column-gap: ${contentGap} !important;
    row-gap: 0.25em !important;
    white-space: normal !important;
    font-size: ${fontSize} !important;
    line-height: 1.25 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  #shopify-installments {
    display: inline-flex !important;
    flex: 0 1 auto !important;
    flex-flow: row nowrap !important;
    align-items: baseline !important;
    gap: ${installmentsGap} !important;
    white-space: nowrap !important;
    margin: 0 !important;
    max-width: 100% !important;
  }

  #shopify-installments * {
    white-space: nowrap !important;
  }

  #shopify-installments p,
  #shopify-installments span {
    display: inline !important;
    line-height: 1.25 !important;
  }

  #shopify-installments svg {
    display: inline-block !important;
    height: ${svgHeight} !important;
    max-height: ${svgHeight} !important;
    width: auto !important;
    vertical-align: middle !important;
    flex-shrink: 0 !important;
    ${svgTransform}
  }

  /* Full-width second row so this is the only thing on line 2, right-aligned */
  #shopify-installments-cta,
  #shopify-installments #shopify-installments-cta {
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    flex: 0 0 100% !important;
    flex-basis: 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    white-space: nowrap !important;
    text-align: right !important;
    font-size: ${ctaFontSize} !important;
    line-height: 1.25 !important;
    pointer-events: auto !important;
    cursor: pointer !important;
  }

  .pr-1\\.5 {
    padding-right: 0 !important;
  }
`;
  }

  return `
  #shopify-installments-content {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: ${contentAlign} !important;
    gap: ${contentGap} !important;
    white-space: nowrap !important;
    font-size: ${fontSize} !important;
    line-height: 1.25 !important;
    width: max-content !important;
    max-width: 100% !important;
    margin: 0 !important;
  }

  #shopify-installments-content > * {
    flex: 0 0 auto !important;
    white-space: nowrap !important;
  }

  #shopify-installments {
    display: inline-flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    align-items: ${contentAlign} !important;
    gap: ${installmentsGap} !important;
    white-space: nowrap !important;
    margin: 0 !important;
  }

  #shopify-installments * {
    white-space: nowrap !important;
  }

  #shopify-installments p,
  #shopify-installments span,
  #shopify-installments-cta {
    display: inline !important;
    line-height: 1.25 !important;
  }

  #shopify-installments svg {
    display: inline-block !important;
    height: ${svgHeight} !important;
    max-height: ${svgHeight} !important;
    width: auto !important;
    vertical-align: middle !important;
    flex-shrink: 0 !important;
    position: relative !important;
    top: 0 !important;
    ${svgTransform}
  }

  #shopify-installments-cta {
    display: inline !important;
    white-space: nowrap !important;
    margin: 0 !important;
    padding: 0 !important;
    width: auto !important;
    max-width: none !important;
    flex-shrink: 0 !important;
    font-size: ${brandShopPay ? ctaFontSize : 'inherit'} !important;
    line-height: 1.25 !important;
    ${brandShopPay ? 'padding-left: 3px !important;' : ''}
    pointer-events: auto !important;
    cursor: pointer !important;
  }
`;
}

const SHOP_PAY_BRAND_CSS = `
  #shopify-installments svg,
  #shopify-installments svg path,
  #shopify-installments svg rect,
  #shopify-installments svg circle,
  #shopify-installments svg polygon,
  #shopify-installments svg g {
    fill: ${SHOP_PAY_BRAND_COLOR} !important;
    color: ${SHOP_PAY_BRAND_COLOR} !important;
  }
`;

function injectInstallmentsStyle(root, options) {
  if (!root) return;

  let style = root.getElementById(STYLE_ID);
  const css = getInstallmentsCss(options);

  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    root.appendChild(style);
  }

  style.textContent = css;
}

function injectShopPayBrandStyle(root) {
  if (!root) return;

  let style = root.getElementById(SHOP_PAY_BRAND_STYLE_ID);
  if (!style) {
    style = document.createElement('style');
    style.id = SHOP_PAY_BRAND_STYLE_ID;
    root.appendChild(style);
  }

  style.textContent = SHOP_PAY_BRAND_CSS;
}

function applyMobileCtaStack(root) {
  const content = root.querySelector('#shopify-installments-content');
  const installments = root.querySelector('#shopify-installments');
  const cta = root.querySelector('#shopify-installments-cta');
  if (!content || !cta) return;

  // Row + wrap: financing stays on line 1, CTA forced to line 2 via flex-basis 100%
  content.style.setProperty('display', 'flex', 'important');
  content.style.setProperty('flex-direction', 'row', 'important');
  content.style.setProperty('flex-wrap', 'wrap', 'important');
  content.style.setProperty('justify-content', 'flex-end', 'important');
  content.style.setProperty('align-items', 'baseline', 'important');
  content.style.setProperty('width', '100%', 'important');
  content.style.setProperty('max-width', '100%', 'important');
  content.style.removeProperty('margin-left');

  if (installments) {
    installments.style.setProperty('display', 'inline-flex', 'important');
    installments.style.setProperty('flex-direction', 'row', 'important');
    installments.style.setProperty('flex-wrap', 'nowrap', 'important');
    installments.style.setProperty('align-items', 'baseline', 'important');
  }

  // If CTA is nested inside installments, still force it onto its own flex row
  if (installments && installments.contains(cta)) {
    installments.style.setProperty('display', 'flex', 'important');
    installments.style.setProperty('flex-wrap', 'wrap', 'important');
    installments.style.setProperty('justify-content', 'flex-end', 'important');
  }

  cta.style.setProperty('display', 'flex', 'important');
  cta.style.setProperty('justify-content', 'flex-end', 'important');
  cta.style.setProperty('flex-basis', '100%', 'important');
  cta.style.setProperty('flex-grow', '0', 'important');
  cta.style.setProperty('flex-shrink', '0', 'important');
  cta.style.setProperty('width', '100%', 'important');
  cta.style.setProperty('margin', '0', 'important');
  cta.style.setProperty('padding', '0', 'important');
  cta.style.setProperty('text-align', 'right', 'important');
}

/**
 * CSS-only styling for text/logo. Mobile CTA stack uses light inline layout
 * styles only (no text mutation) so Affirm click handlers stay intact.
 */
function styleInstallmentsHost(el, options) {
  options = options || {};
  const wrapCtaOnMobile = !!options.brandShopPay && isMobileViewport();

  const apply = () => {
    if (!el.shadowRoot?.querySelector('#shopify-installments-content')) return false;

    injectInstallmentsStyle(el.shadowRoot, options);
    if (options.brandShopPay) {
      injectShopPayBrandStyle(el.shadowRoot);
    }

    if (wrapCtaOnMobile) {
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.removeProperty('margin-left');
      el.style.setProperty('white-space', 'normal', 'important');
      applyMobileCtaStack(el.shadowRoot);
    } else {
      el.style.setProperty('display', 'inline-block', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.style.removeProperty('width');
      el.style.removeProperty('margin-left');
      el.style.setProperty('white-space', 'nowrap', 'important');
    }
    return true;
  };

  if (apply()) return;

  let attempts = 40;

  const tryApply = () => {
    if (apply()) return;
    if (attempts-- > 0) requestAnimationFrame(tryApply);
  };

  tryApply();
}

function styleCartInstallments() {
  document.querySelectorAll('.cart__installments shopify-payment-terms').forEach((el) => {
    styleInstallmentsHost(el);
  });
}

function styleAnticProductInstallments() {
  document
    .querySelectorAll('.product-information.section[data-product-handle="antic-bike"] shopify-payment-terms')
    .forEach((el) => {
      styleInstallmentsHost(el, { brandShopPay: true });
    });
}

function refreshAnticProductInstallmentStyles() {
  document
    .querySelectorAll('.product-information.section[data-product-handle="antic-bike"] shopify-payment-terms')
    .forEach((el) => {
      if (!el.shadowRoot?.querySelector('#shopify-installments-content')) return;
      injectInstallmentsStyle(el.shadowRoot, { brandShopPay: true });
      injectShopPayBrandStyle(el.shadowRoot);
      if (isMobileViewport()) {
        applyMobileCtaStack(el.shadowRoot);
      }
    });
}

function styleAllInstallments() {
  styleCartInstallments();
  styleAnticProductInstallments();
}

customElements.whenDefined('shopify-payment-terms').then(styleAllInstallments);
document.addEventListener('DOMContentLoaded', () => {
  styleAllInstallments();

  const summary = document.querySelector('.cart-drawer__summary');
  if (summary) {
    new MutationObserver(() => styleCartInstallments()).observe(summary, {
      childList: true,
      subtree: true,
    });
  }

  const anticProductInfo = document.querySelector(
    '.product-information.section[data-product-handle="antic-bike"]'
  );
  if (anticProductInfo) {
    new MutationObserver(() => styleAnticProductInstallments()).observe(anticProductInfo, {
      childList: true,
      subtree: true,
    });
  }
});
document.addEventListener('cart:update', () => requestAnimationFrame(styleCartInstallments));
window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
  requestAnimationFrame(styleAllInstallments);
  requestAnimationFrame(refreshAnticProductInstallmentStyles);
});
